<script setup lang="ts">
import { primeVueTwMerger } from '@/components/primevue'
import { useLayout } from '@/composable/useLayout'
import { cn } from '@/utils'
import { computed } from 'vue'

const { toggleSidebar, layoutState } = useLayout()
const sidebarClasses = computed(() => {
  return cn('sidebar', { '-translate-x-sidebar': !layoutState.sidebarVisible.value })
})
const collapseButtonClasses = computed(() => {
  return cn('collapse-button', {
    '-translate-x-sidebar rotate-180': !layoutState.sidebarVisible.value,
  })
})
const backdropClasses = computed(() => {
  return cn('backdrop', { 'opacity-100 h-full lg:invisible': layoutState.sidebarVisible.value })
})
</script>

<template>
  <div :class="sidebarClasses">
    <slot />
  </div>

  <Button
    icon="pi pi-chevron-left"
    :class="collapseButtonClasses"
    size="small"
    severity="secondary"
    rounded
    :pt="{
      root: 'bg-surface-350 border-surface-350 text-surface-100 hover:bg-surface-400 hover:border-surface-400 hover:text-surface-100 w-8 h-8 flex items-center',
    }"
    :pt-options="{ mergeProps: primeVueTwMerger }"
    @click="toggleSidebar()"
  />

  <div :class="backdropClasses"></div>
</template>

<style lang="postcss">
.sidebar {
  @apply fixed bottom-4 left-4 top-4 z-[998] w-[calc(var(--sidebar-width)+1rem)] select-none overflow-y-auto rounded bg-surface-0 p-6 pb-4 pt-6 shadow transition-transform;
}
.collapse-button {
  @apply !fixed left-[calc(var(--sidebar-width)+1rem)] top-12 z-[999] shadow transition-transform duration-200;
}
.backdrop {
  @apply fixed left-0 z-99 block h-0 w-full bg-black bg-opacity-40 opacity-0 transition-opacity duration-200;
}
</style>
